var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var TriangleDownIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 35
  }), React.createElement("path", {
    d: "M31.5991 33.1904C29.624 35.262 26.3163 35.2559 24.3488 33.177L1.84125 9.39555C-1.17835 6.20504 1.08902 0.950572 5.4819 0.958636L50.5842 1.04143C54.977 1.04949 57.2251 6.31225 54.1938 9.49166L31.5991 33.1904Z"
  }));
};
export var TriangleDownIconGlyph = function (props) {
  return React.createElement(TriangleDownIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};